import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page-width-inner py-16 tablet:py-52"
}
const _hoisted_2 = { class: "pb-16 tablet:pb-32" }
const _hoisted_3 = {
  key: 0,
  class: "h6 tablet:h5 pb-4"
}
const _hoisted_4 = {
  key: 1,
  class: "text-14 text-black-700"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_grid_item = _resolveComponent("grid-item")
  const _component_splide_slide = _resolveComponent("splide-slide")
  const _component_splide = _resolveComponent("splide")

  return ($data.products.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          ($props.title)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_3, _toDisplayString($props.title), 1))
            : _createCommentVNode("", true),
          ($props.subtitle)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($props.subtitle), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_splide, {
          class: "-mr-16 tablet:-mr-52",
          options: {
        type: 'slide',
        arrows: false,
        pagination: false,
        fixedWidth: $props.columnCountDesktop === 4 ? '22.5%' : '17.5%',
        perMove: 1,
        gap: '2rem',
        mediaQuery: 'max',
        breakpoints: {
          768: {
            fixedWidth: $props.columnCountMobile === 1 ? '88%' : '63%',
            gap: '1rem',
          },
        },
      }
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.products, (product) => {
              return (_openBlock(), _createBlock(_component_splide_slide, {
                key: product.id
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_grid_item, {
                    product: product,
                    "lazyload-media": true
                  }, null, 8, ["product"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["options"])
      ]))
    : _createCommentVNode("", true)
}